import { GzAnimatedHighlightBoxWebComponent } from './GzAnimatedHighlightBoxWebComponent';
import { GzAnimatedHighlightBoxManager } from './GzAnimatedHighlightBoxManager';

export { GzAnimatedHighlightBoxWebComponent, GzAnimatedHighlightBoxManager };
